module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAABHNCSVQICAgIfAhkiAAAANxJREFUKJGFUcFxwkAM3BXpC7kQyIOZZKjCpoob+2dfIXY6SDN5IuXhnDkBGfQ6Sbsr3YqoIyely1yXnNbgcF5KLoFwOC9Oa0pKx6UGPxJyUvquhfN7A4x9V0O4PaZhXle43lRzUjFRALD3zxtRxr4LSrlvMaau7hdBKcCgYLZNDr2cVJzcm1j42LNwXi/0XSuA670TpJxIOQXGH+YN4BN1//lnjq7u5KSvVkJOymmYpez2Ci8mSvevdedpmO8PFMCV7ayLAGBiS324Mt2PH00gFJKTe8C1mBEuD+AXsw9u8AIAnNUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexFTboxtimer.png
// module id = qRNP
// module chunks = 1